  <div class="row card-group text-center text-grey">
    <div>
      <div class="card-header border-primary"
           style="background-color: var(--s-primary-color);" [style.cursor]="cardVariable.cursor"
           (click)="navigateToComponent(cardVariable.title)">
        <h3 class="my-0 fw-normal" style="color: white">
          <i class="bi synchpc-primary"
             [ngClass]="cardVariable.icon"
             style="color: white !important"></i>
          {{ cardVariable.title }}
        </h3>
      <!-- Removed the extra closing div -->
      <div class="card-body" style="background-color: #f7f7f7">
        <div class="row">
          <div class="col" *ngFor="let data of cardVariable.data; let i = index">
            <p *ngIf="data != '...'"
               matTooltip="{{ cardVariable.tooltip[i] }}"
               class="card-title pricing-card-title h5"
               [style.cursor]="cardVariable.cursor || 'default'"
               (click)="onDataClick(cardVariable.title, cardVariable.labels[i])"
               [ngStyle]="{
               color:
               data>
              0 &&
              data > cardVariable.threshold[i] &&
              cardVariable.threshold[i] > 0
              ? 'orange'
              : 'var(--s-primary-color)'
              }"
              >
              {{ data }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col" *ngFor="let lb of cardVariable.labels; let i = index">
            <p class="h6">
              {{ lb }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
